// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"55b60c88","453":"e507aec9","455":"bef02bdc","977":"57481b33"}[chunkId] + ".chunk.js";
};